"use client";
import Image from "next/image";
import Fade from "embla-carousel-fade";
import { Carousel, CarouselContent, CarouselItem } from "components/ui/carousel";
import { ImageSliderProps } from "types/tiles";
import ImageSliderButtons from "./ImageSliderButtons";

const ImageSlider = ({ images }: { images: ImageSliderProps[] }) => {
  return (
    <div className="z-[10] w-full !overflow-visible rounded-lg object-cover @3xl:rounded-2xl">
      <Carousel plugins={[Fade()]}>
        <CarouselContent className="!ml-0 h-full w-full">
          {images?.map((image, index) => (
            <CarouselItem key={`${index}${image.src ? `_${image.src.split("/").pop()}` : ""}`}>
              {image.top && (
                <div className="absolute right-4 top-4 z-20 rounded bg-pink-format px-3 py-[7px] text-xs uppercase !leading-[18px] tracking-[0.06em] text-purple-700 @3xl:right-8 @3xl:top-8">
                  {image.top}
                </div>
              )}
              <div className="group relative h-[450px] w-full overflow-hidden rounded-2xl !rounded-b-none">
                <Image
                  alt={image.alt || "template_image"}
                  sizes="100vw"
                  src={image.src}
                  decoding="async"
                  data-nimg="fill"
                  className="object-cover blur-0 grayscale-0 transition duration-500 ease-in-out hover:scale-105 group-hover:scale-105"
                  fill
                />
              </div>
              <div className="z-30 flex w-full flex-col items-center justify-between rounded-lg !rounded-t-none bg-offwhite p-6 pt-5 @3xl:flex-row @3xl:rounded-2xl @3xl:px-10 @3xl:py-5">
                <div className="mb-6 flex w-full flex-col justify-between @3xl:mb-0 @3xl:w-auto @3xl:justify-start">
                  <p className="text-primary font-hatch-serif !text-[20px] !leading-[28px] !tracking-[-0.03em] @3xl:!text-[22px] @3xl:!leading-[33px]">
                    {image.title}
                  </p>
                  <p className="text-secondarry line-clamp-1 cursor-default text-[16px] leading-[24px] tracking-[.01em] @3xl:flex-row @3xl:items-center">
                    {image.subtitle}
                  </p>
                </div>
                <div className="flex w-full items-center justify-between whitespace-nowrap @3xl:w-auto @3xl:justify-start">
                  <ImageSliderButtons />
                </div>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
    </div>
  );
};

export default ImageSlider;
